// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kGiF","label":"styles_label__1oR2y"};